/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ActivationDetails {
    getFixupPrototypeFunction() { return ActivationDetails.fixupPrototype; }

    static newInstance(model: Partial<ActivationDetails>): ActivationDetails {
        let obj = Object.assign(new ActivationDetails(), model);
        ActivationDetails.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ActivationDetails>): ActivationDetails {
        if (!model) return null;
        return ActivationDetails.newInstance(<ActivationDetails> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ActivationDetails) {
        if (!obj) return;

        models.ActivationDetails.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ActivationDetails): boolean {
        Object.setPrototypeOf(obj, ActivationDetails.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Status of the activation details
     */
    status: models.ActivationDetailsStatus;

    /**
     * Message of the activation details
     */
    message: string;

}
